import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class VendorPayment {
  async fetch(page, perPage) {
    const response = await ajaxService.get(
      `/accounts/vendor-payments?page=${page}&perPage=${perPage}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addTransaction(data) {
    const response = await ajaxService.post(
      `/accounts/vendor-payments/transaction`,
      data
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const vendorPaymentService = new VendorPayment();
export default vendorPaymentService;
